import React, { useEffect } from "react";
import showImages from "../constants/showImages";
import showDescriptions from "../constants/showDescriptions";
import showPresenters from "../constants/showPresenters";
import "../style/components/modal.css";

export function ShowDescriptionModal({ showTitle, onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const showArt = showImages[showTitle] ? `${process.env.PUBLIC_URL}/${showImages[showTitle]}` : "";
  const description = showDescriptions[showTitle] || "Brak dostępnego opisu dla tej audycji.";

  const presenter = showPresenters[showTitle] || null;
  const presenterName = presenter?.name || "";
  const presenterImage = presenter?.image ? `${process.env.PUBLIC_URL}/presenters/${presenter.image}` : "";

  return (
    <div
      className="modal-overlay"
      onClick={handleBackdropClick}
      tabIndex={0}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="modal-content">
        <div className="modal-header">
          <h2 id="modal-title">{showTitle}</h2>
          <button className="close-button" onClick={onClose} aria-label="Zamknij modal">
            <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
            </svg>
          </button>
        </div>

        <div className="modal-body">
          {showArt && (
            <div className="show-image">
              <img src={showArt} alt={`${showTitle} artwork`} />
            </div>
          )}

          <div className="show-description" style={{ flex: 1 }}>
            <p>{description}</p>
          </div>

          {presenterName && (
            <div className="presenter">
              <div className="presenter-art">
                {presenterImage ? (
                  <img src={presenterImage} alt={presenterName} />
                ) : (
                  <div className="presenter-placeholder" />
                )}
              </div>
              <div className="presenter-meta">
                <div className="presenter-name">{presenterName}</div>
                <div className="presenter-role">Prowadzący</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}